<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <base-material-card
          :title="$t('KOBRA-BACKEND - alle Daten im Überblick')"
          color="red"
        >
          <v-row>
            <v-col cols="12">
              <p>
                {{
                  $t(
                    "Nutzen Sie den KOBRA Konfigurator zum Überprüfen Ihrer zertifizierten Haus, Brand- und Schallschutztüren, zum Abrufen aller Zertifikate & Unterlagen und zum bestellen der Plaketten."
                  )
                }}
              </p>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col lg="6" cols="12">
        <base-material-stats-card
          icon="mdi-account"
          :title="$t('Produzierte Türen')"
          :value="
            dashboardData.hasOwnProperty('doors_produced')
              ? dashboardData.doors_produced.toString()
              : '-'
          "
          :subText="
            (dashboardData.hasOwnProperty('doors_draft')
              ? dashboardData.doors_draft.toString()
              : '-') +
              ' ' +
              $t('Türen in Entwürfen')
          "
          color="info"
        >
        </base-material-stats-card>
      </v-col>
      <v-col lg="6" cols="12">
        <base-material-stats-card
          icon="mdi-file-document"
          :title="$t('Orders')"
          :value="
            dashboardData.hasOwnProperty('orders_produced')
              ? dashboardData.orders_produced.toString()
              : '-'
          "
          :subText="
            (dashboardData.hasOwnProperty('orders_draft')
              ? dashboardData.orders_draft.toString()
              : '-') +
              ' ' +
              $t('Entwürfe')
          "
        >
        </base-material-stats-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        lg="6"
        v-if="this.$auth.user().permissions.includes('order.editall')"
      >
        <base-material-card :text="$t('Aufträge zu bestätigen')" color="green">
          <v-card-text>
            <div v-if="dashboardData.orders_to_confirm">
              <v-data-table
                :headers="orderHeaders"
                :items="dashboardData.orders_to_confirm"
                v-model="dashboardData.orders_to_confirm"
                hide-default-footer
                item-key="id"
                class="elevation-1"
              >
                <template v-slot:item.name="{ item }">
                  <a :href="'/order/' + item.id">{{ item.project }}</a>
                </template>
                <template v-slot:item.expire="{ item }">
                  {{ item.expire | formatDate }}
                </template>
              </v-data-table>
            </div>
            <div v-else>
              <p
                v-if="
                  dashboardData.orders_to_confirm &&
                    dashboardData.orders_to_confirm.length == 0
                "
              >
                {{ $t("Keine Daten vorhanden") }}
              </p>
              <v-progress-linear indeterminate v-else></v-progress-linear>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
      <v-col
        cols="12"
        lg="6"
        v-if="this.$auth.user().permissions.includes('document.create')"
      >
        <base-material-card :text="$t('Abgelaufene Dokumente')" color="red">
          <v-card-text>
            <v-data-table
              :headers="documentHeaders"
              :items="dashboardData.expired_documents"
              v-model="dashboardData.expired_documents"
              hide-default-footer
              item-key="id"
              class="elevation-1"
              v-if="dashboardData.expired_documents"
            >
              <template v-slot:item.name="{ item }">
                <a :href="'/document/' + item.id">{{ item.name }}</a>
              </template>
              <template v-slot:item.expire="{ item }">
                {{ item.expire | formatDate }}
              </template>
            </v-data-table>
            <div v-else>
              <p
                v-if="
                  dashboardData.expired_documents &&
                    dashboardData.expired_documents.length == 0
                "
              >
                {{ $t("Keine Daten vorhanden") }}
              </p>
              <v-progress-linear indeterminate v-else></v-progress-linear>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="6" cols="12">
        <base-material-card :text="$t('categories')" color="orange">
          <v-card-text>
            <div v-if="dashboardData.categories">
              <v-data-table
                :headers="categoryHeaders"
                :items="dashboardData.categories"
                v-model="dashboardData.categories"
                hide-default-footer
                item-key="id"
                class="elevation-1"
              >
              </v-data-table>
            </div>
            <div v-else>
              <p
                v-if="
                  dashboardData.categories &&
                    dashboardData.categories.length == 0
                "
              >
                {{ $t("Keine Daten vorhanden") }}
              </p>
              <v-progress-linear indeterminate v-else></v-progress-linear>
            </div>
            <div
              v-if="
                dashboardData.companyNumberRanges &&
                  dashboardData.companyNumberRanges.length
              "
            >
              <br />
              <h4>{{ $t("Spezielle Nummernkreise") }}</h4>
              <ul>
                <li
                  v-for="(numberRange,
                  index) in dashboardData.companyNumberRanges"
                  :key="index"
                >
                  {{ numberRange.name }} [ {{ $t("Aktuelle Nummer") }}:
                  {{ numberRange.number }} ]
                </li>
              </ul>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
      <v-col lg="6" cols="12">
        <base-material-stats-card
          icon="mdi-delete"
          :title="$t('Orders') + ' ' + $t('deleted')"
          :value="
            dashboardData.hasOwnProperty('orders_deleted')
              ? dashboardData.orders_deleted.toString()
              : '-'
          "
          :subText="
            (dashboardData.hasOwnProperty('doors_deleted')
              ? dashboardData.doors_deleted.toString()
              : '-') +
              ' ' +
              $t('Positionen gelöscht')
          "
          color="red"
        >
        </base-material-stats-card>
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col
        cols="12"
        lg="12"
        v-if="this.$auth.user().permissions.includes('labelEntry.create')"
      >
        <base-material-card>
          <v-card-text>
            <v-switch label="Suggest all" v-model="suggestAll"></v-switch>

            <v-data-table
              :headers="suggestionHeaders"
              :items="computedOrderSuggestions"
              v-model="selectedOrderSuggestions"
              hide-default-footer
              class="elevation-1"
              show-select
              item-key="uid"
              loading="true"
            >
              <template v-slot:item.qty="{ item }">
                <v-text-field
                  name="qty"
                  label="Qty"
                  v-model="item.qty"
                  @change="item.to = Number(item.from) + Number(item.qty) - 1"
                  type="number"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-btn class="ma-1" color="primary" @click="createSuggestedOrders">
              {{ $t("create") }}
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import { fetchSuggestion, saveItem } from "../labelorders/shared/services";
import { fetchData } from "./shared/services";

export default {
  name: "app-dashboard",
  data() {
    return {
      suggestionHeaders: [
        {
          text: "Numberrange",
          value: "number_range.name"
        },
        {
          text: "Labeltype",
          value: "label_type.name"
        },
        {
          text: "From",
          value: "from"
        },
        {
          text: "to",
          value: "to"
        },
        {
          text: "qty",
          value: "qty"
        },
        {
          text: "on stock",
          value: "label_type.qty_on_stock"
        },
        {
          text: "on order",
          value: "label_type.qty_on_order"
        },
        {
          text: "Company",
          value: "company.name"
        }
      ],
      documentHeaders: [
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Ablauf",
          value: "expire"
        }
      ],
      orderHeaders: [
        {
          text: "Projekt",
          value: "name"
        },
        {
          text: "Mitglied",
          value: "customer.company.name"
        }
      ],
      categoryHeaders: [
        {
          text: "Kategorie",
          value: "categoryName"
        },
        {
          text: "Gesamtstückzahl",
          value: "total"
        }
      ],
      orderSuggestions: [],
      selectedOrderSuggestions: [],
      suggestAll: false,
      dashboardData: {}
    };
  },
  computed: {
    computedOrderSuggestions() {
      if (!this.suggestAll) {
        return this.orderSuggestions.filter(sug => sug.qty > 0);
      } else {
        return this.orderSuggestions;
      }
    }
  },
  mounted() {
    if (this.$auth.user().permissions.includes("labelEntry.create")) {
      this.getOrderSuggestons();
    }

    fetchData().then(res => {
      this.dashboardData = res;
    });
    //setInterval(this.getOrderSuggestons, 5000);
  },
  methods: {
    getOrderSuggestons() {
      fetchSuggestion().then(res => {
        this.orderSuggestions = res.data.map((item, index) => ({
          uid: index,
          qty: item.to - item.from + 1,
          ...item
        }));
      });
    },
    createSuggestedOrders() {
      let saveItems = [];
      this.selectedOrderSuggestions.map(orderSuggestion => {
        saveItems.push(saveItem(null, orderSuggestion, null));
      });
      Promise.all(saveItems).then(values => {
        this.$router.push({ name: "labelorder.index" });
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
